export const months = {
  tr: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
  en: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

export const weekDays = {
  tr: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  en: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
};
